import { apiSlice } from './apiSlice';

export interface UploadBinaryResponse {
  url: string;
  meta: {
    originalname: string;
    filename: string;
    mimetype: string;
    size: number;
  };
}

export interface AssignFolderResponse {
  filename: string;
  url: string;
}

export const uploadApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Upload binary file
    uploadBinary: builder.mutation<UploadBinaryResponse, File>({
      query: (file) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: '/upload',
          method: 'POST',
          body: formData,
        };
      },
    }),

    // Assign folder
    assignFolder: builder.mutation<AssignFolderResponse, { folder: string; filename: string }>({
      query: ({ folder, filename }) => ({
        url: `/upload/${folder}`,
        method: 'POST',
        body: { filename },
      }),
    }),
  }),
});

export const { useUploadBinaryMutation, useAssignFolderMutation } = uploadApi;
